module.exports = __webpack_public_path__ + "static/media/Bot_Nova.b95b8e2d.png";